// extracted by mini-css-extract-plugin
module.exports = {"languagesList":"Languages_languagesList__EH185"};